<script setup>
import apiManager from '@/api';
import CancelRegistration from '@/components/cancelRegistration/CancelRegistration.vue';
import { useToast } from 'vue-toastification';
import { defineProps, ref } from 'vue';

const props = defineProps({
  id: String,
});

const disableButton = ref(false);

const toast = useToast();

const cancel = async () => {
  try {
    await apiManager.reservations.cancel({ id: props.id });
    toast.success('Your registration was successfully cancelled');
    disableButton.value = true;
  } catch (e) {
    toast.error('There was a problem cancelling your registration');
  }
};

</script>
<template>
<cancel-registration :disableButton="disableButton" @cancel-registration="cancel" />
</template>
